// Pink petals (M45 — cherry grove). PURE (ENG-1). A ground-cover block that stacks
// 1..4 petals in a cell: right-clicking it with more petals adds one (up to the
// cap), and it may only sit on a solid top surface. These are the pure rules.

/** Most petals a single pink-petals block holds. */
export const PINK_PETALS_MAX = 4;

/** The petal count after adding one more (clamped at the cap). */
export function nextPetalAmount(current: number): number {
  return Math.min(PINK_PETALS_MAX, current + 1);
}

/** Whether the cell can still take another petal. */
export function canAddPetal(current: number): boolean {
  return current < PINK_PETALS_MAX;
}

const PETAL_GROUND = new Set(['grass_block', 'dirt', 'coarse_dirt', 'podzol', 'moss_block', 'rooted_dirt', 'mycelium']);

/** Whether pink petals may be placed on top of this ground block. */
export function canPlacePetalsOn(block: string): boolean {
  return PETAL_GROUND.has(block);
}

/** Petals dropped when a pink-petals block is broken (one item per petal). */
export function petalDrops(amount: number): number {
  return Math.max(1, amount);
}
